import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from '../../components/DataTable';
const SalesManagersPage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const columns = [
        {
            key: 'name',
            label: 'Name',
            type: 'text',
            required: true,
            width: 'w-48',
        },
        {
            key: 'email',
            label: 'Email',
            type: 'text',
            required: false,
            width: 'w-64',
        },
        {
            key: 'phone',
            label: 'Phone',
            type: 'text',
            required: false,
            width: 'w-40',
        },
        {
            key: 'territory',
            label: 'Territory',
            type: 'text',
            required: false,
            width: 'w-48',
        },
        {
            key: 'notes',
            label: 'Notes',
            type: 'text',
            required: false,
            width: 'w-64',
        },
    ];
    const fetchData = async () => {
        try {
            setLoading(true);
            const response = await fetch('/api/sales-managers', {
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Failed to fetch sales managers');
            }
            const result = await response.json();
            setData(result);
        }
        catch (error) {
            console.error('Error loading sales managers:', error);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const handleAdd = async (newRow) => {
        try {
            const response = await fetch('/api/sales-managers', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(newRow),
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to add sales manager');
            }
            await fetchData();
        }
        catch (error) {
            console.error('Add failed:', error);
            throw error;
        }
    };
    const handleUpdate = async (id, updatedRow) => {
        try {
            const response = await fetch(`/api/sales-managers/${id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify(updatedRow),
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to update sales manager');
            }
            await fetchData();
        }
        catch (error) {
            console.error('Update failed:', error);
            throw error;
        }
    };
    const handleDelete = async (id) => {
        try {
            const response = await fetch(`/api/sales-managers/${id}`, {
                method: 'DELETE',
                credentials: 'include',
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || 'Failed to delete sales manager');
            }
            await fetchData();
        }
        catch (error) {
            console.error('Delete failed:', error);
            throw error;
        }
    };
    if (loading) {
        return (_jsx("div", { className: "min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-8", children: _jsx("div", { className: "max-w-7xl mx-auto", children: _jsx("div", { className: "flex justify-center items-center h-64", children: _jsx("div", { className: "text-secondary-600", children: "Loading..." }) }) }) }));
    }
    return (_jsx("div", { className: "min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-8", children: _jsxs("div", { className: "max-w-7xl mx-auto", children: [_jsxs("div", { className: "mb-8", children: [_jsx(Link, { to: "/dashboard", className: "text-primary-600 hover:text-primary-700 mb-4 inline-block", children: "\u2190 Back to Dashboard" }), _jsx("h1", { className: "text-3xl font-bold text-secondary-900", children: "Sales Managers" }), _jsx("p", { className: "text-secondary-600 mt-2", children: "Manage your sales team and assign them to customers" })] }), _jsx("div", { className: "card", children: _jsx(DataTable, { columns: columns, data: data, onAdd: handleAdd, onUpdate: handleUpdate, onDelete: handleDelete }) })] }) }));
};
export default SalesManagersPage;
